export const breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '992px',
  xl: '1230px',
  '2xl': '1440px',
  print: 'print',
} as const;
